const getters = {
  /** app */
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  /** user */
  id: state => state.user.id,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  UploadPic: state => state.user.UploadPic,

  allRouters: state => state.router.routers,
  authFinish: state => state.router.authFinish,
  currentPageAuth: state => state.router.currentPageAuth,
  specialAuth: state => state.router.specialAuth,
  city: state => state.router.citys,
  cityOptions: state => state.router.cityOptions
}
export default getters
